import React, { useEffect, useState } from "react";
import TableLayout from "../components/table";
import { Box, Paper } from "@mui/material";
import { Typography } from "@mui/material";
import { showloader } from "../store/gloabalState";
import { useSetRecoilState } from "recoil";
import { getTransactions } from "../services/httpCalls";
import { getcookieFunc } from "../utils/useCookies";
import { Link } from "react-router-dom";
import { DateConvert } from "../utils/dateConverter";
import { Table } from "antd";
import { transactionClicked } from "../store/gloabalState";
import UnassignedTransactions from "../components/unassigned-transactions";
import OngoingTransactions from "../components/ongoing-transactions";

export default function Home() {

  return (
    <Box>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="h5" sx={{ paddingBottom: "1rem" }}>
          Unassigned Transactions
        </Typography>
        <UnassignedTransactions/>
      </Box>
      <Box sx={{ padding: "1rem" }}>
        <Typography variant="h5" sx={{ paddingBottom: "1rem" }}>
          Ongoing Transactions
        </Typography>
        <OngoingTransactions/>
      </Box>
    </Box>
  );
}
